<template>
    <rkm-area
        background-color="success"
        closed
        header-prefix-text="P"
        title="Plano"
        type="box"
    >
        <template v-if="!item.isAtendimentoSaudeBucal">
            <rkm-row>
                <rkm-col cols="12">
                    <Item
                        :get-value="() => item.plano.descricao"
                        label="Informações adicionais sobre o plano de cuidado"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxIntervencao :item="item" />
                </rkm-col>
            </rkm-row>
        </template>

        <rkm-row>
            <rkm-col cols="12">
                <BoxProcedimentoClinico :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.isAtendimentoSaudeBucal">
            <rkm-col cols="12">
                <BoxOdontograma :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxPrescricaoMedicamento :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    title="Solicitações de exames comuns"
                    type="fieldset"
                    no-margin-top
                    class="pt-0"
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <BoxExameSolicitado :item="item" />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <BoxTriagemNeonatal :item="item" />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <BoxSolicitacaoExameComum :item="item" />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxSolicitacaoExameAltoCusto :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxTesteRapido :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxAtestado :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxDeclaracaoComparecimento :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxCartaMedica :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxOrientacao :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxEncaminhamento :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxCompartilhamentoCuidado :item="item" />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import BoxAtestado from './components/atestado/Index'
import BoxCartaMedica from './components/carta-medica/Index'
import BoxCompartilhamentoCuidado from './components/compartilhamento-cuidado/Index'
import BoxDeclaracaoComparecimento from './components/declaracao-comparecimento/Index'
import BoxEncaminhamento from './components/encaminhamento/Index'
import BoxIntervencao from './components/intervencao/Index'
import BoxOdontograma from './components/odontograma/Index'
import BoxOrientacao from './components/orientacao/Index'
import BoxPrescricaoMedicamento from './components/prescricao-medicamento/Index'
import BoxProcedimentoClinico from './components/procedimento-clinico/Index'
import BoxSolicitacaoExameComum from './components/solicitacao-exame-comum/Index'
import BoxExameSolicitado from './components/exame-solicitado/Index'
import BoxTriagemNeonatal from './components/triagem-neonatal/Index'
import BoxSolicitacaoExameAltoCusto from './components/solicitacao-exame-alto-custo/Index'
import BoxTesteRapido from './components/teste-rapido/Index'
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {
        BoxAtestado,
        BoxCartaMedica,
        BoxCompartilhamentoCuidado,
        BoxDeclaracaoComparecimento,
        BoxEncaminhamento,
        BoxIntervencao,
        BoxOdontograma,
        BoxOrientacao,
        BoxPrescricaoMedicamento,
        BoxProcedimentoClinico,
        BoxSolicitacaoExameComum,
        BoxExameSolicitado,
        BoxTriagemNeonatal,
        BoxSolicitacaoExameAltoCusto,
        BoxTesteRapido,
        Item,
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>